import { TsSource } from "./tenderForm.module";
import { CurrencyCodeIso } from "../../common/constants/currency";
import { TenderCreationModel } from "./tenderForm.schema";

export const Countries = [
	{ key: "fr", value: "FR" },
	{ key: "be", value: "BE" },
	{ key: "de", value: "DE" },
	{ key: "nl", value: "NL" },
];

export const TS_SOURCE = {
	[TsSource.REALIZED_ENDPOINT]: "Imported Tourbillon",
	[TsSource.GECO]: "GECO",
	[TsSource.CLUSTER]: "CLUSTER",
	[TsSource.RENEWEX]: "Imported (Renewex)",
	[TsSource.TS_IMPORTER]: "Imported (Importer)",
	[TsSource.TOURBILLON]: "Manual",
	[TsSource.EXTRUDER]: "Extruder",
	[TsSource.RESPY]: "Respy model",
};

export const WindTechnologies = ["wind_onshore", "wind_offshore"];
export const Solar = "solar";
export const DISPLAY_TECHNO_NAME_MAP: Record<string, string> = {
	wind_offshore: "Wind offshore",
	wind_onshore: "Wind onshore",
	solar: "Solar",
};

export const SiteImportTypes = [
	{ key: "universal_template", value: "Universal Template " },
];

export const initialTenderValues: TenderCreationModel = {
	direction: "PPA",
	transactionType: "Physical",
	account: undefined,
	tenderName: "",
	deadline: undefined,
	validityDate: undefined,
	historicalData: [],
	bypassWarning: false,
	realized_data_will_be_added: false,
	pricing_stage: "INDICATIVE",
	has_negative_price_clause: false,
	is_balancing_responsible_party: false,
	currency: CurrencyCodeIso.EUR,
};

export const NO_CLEANED_STATUS = [
	"CLEANED",
	"CLEANING IN_PROGRESS",
	"CLEANING READY",
];
